import { PaymentMethodType } from '@nemuru-eng/js-api-client';
import { InsuranceType } from '@nemuru-eng/js-api-client/slim';
import { z } from 'zod';

import { InclusionFilter } from '@/components/modules/PricingsList/_shared/constants/InclusionFilterSelectOptions';

export const ALL_PAYMENT_METHODS = 'all_payment_methods';

export enum GracePeriod {
  WITH_GRACE_PERIOD = 'with_grace_period',
  WITHOUT_GRACE_PERIOD = 'without_grace_period',
}

export const PricingsFormSchema = z.object({
  paymentMethod: z.nativeEnum(PaymentMethodType).or(z.literal(ALL_PAYMENT_METHODS)).nullable(),
  gracePeriod: z.nativeEnum(InclusionFilter),
  setupFee: z.nativeEnum(InclusionFilter),
  insurances: z.array(z.nativeEnum(InsuranceType)),
});
